angular.module('gym.contacts').controller('AddEzidebitPaymentDetailsCtrl', ["$scope", "$modalInstance", "loadingAnimation", "flash", "PaymentDetailsSharingService", "gym", "contact", "customer", "sharingOption", "paymentAccount", function($scope, $modalInstance, loadingAnimation, flash, PaymentDetailsSharingService, gym, contact, customer, sharingOption, paymentAccount) {
  var base, getDefaultPaymentMethod;
  $scope.gym = gym;
  $scope.contact = contact;
  $scope.customer = customer[0].clone();
  $scope.paymentAccount = paymentAccount;
  getDefaultPaymentMethod = function() {
    if (gym.credit_card_provider === 'ezidebit') {
      return 'credit_card';
    } else {
      return 'bank_account';
    }
  };
  if ((base = $scope.customer).payment_method == null) {
    base.payment_method = getDefaultPaymentMethod();
  }
  if (sharingOption.updateThisContactOnly) {
    $scope.customer.customer_ref = void 0;
  }
  $scope.isFormValid = false;
  $scope.sharingOption = sharingOption;
  $scope.$on('contact:paymentMethod:formStatusChanged', function(event, data) {
    return $scope.isFormValid = data;
  });
  $scope.isCustomerExist = function() {
    var ref;
    return ((ref = $scope.customer.customer_ref) != null ? ref.length : void 0) && $scope.customer.active_on_ezidebit;
  };
  $scope.disableForm = function() {
    return $scope.isFormDisabled = true;
  };
  $scope.onCreate = function(customer) {
    if ($scope.sharingOption.updateThisContactOnly) {
      $scope.customer = angular.extend($scope.customer, customer);
      return $scope.customer.doPUT($scope.customer, 'unlink_and_update').then(function(data) {
        return $scope.closeModal();
      });
    } else {
      if ($scope.customer.id) {
        $scope.customer = angular.extend($scope.customer, customer);
        return $scope.customer.save().then(function(data) {
          return $scope.closeModal();
        });
      } else {
        return $scope.contact.post('ezidebit', customer).then(function(data) {
          return $scope.closeModal();
        });
      }
    }
  };
  $scope.onUpdate = function(customer) {
    $scope.customer = angular.extend($scope.customer, customer);
    if ($scope.sharingOption.updateThisContactOnly) {
      return $scope.customer.doPUT($scope.customer, 'unlink_and_update').then(function(data) {
        return $scope.closeModal();
      });
    } else {
      return $scope.customer.save().then(function(data) {
        return $scope.closeModal();
      });
    }
  };
  $scope.closeModal = function() {
    return $modalInstance.close();
  };
  $scope.sharePaymentDetails = function() {
    $modalInstance.dismiss();
    return PaymentDetailsSharingService.share(contact);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
